<template>
    <div class="ml-3 mr-3 no-padding" >
        <go-back-bar></go-back-bar>
        <kt-row v-if="status === 'success'">
            <kt-col>
                <activity-log-filter :action="filterAction" :query="query"></activity-log-filter>
                <kt-table is_responsive dir="ltr" class="table table-hover table-bordered">
                    <thead>
                    <tr>
                        <th class="text-center date" style="width:80px; padding: 12px 5px">id</th>
                        <th class="text-center date">Date</th>
                        <th class="text-center time">Time</th>
                        <th class="text-center ip">Ip</th>
                        <th class="text-center ip">Country</th>
                        <th class="text-center">Description</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-bind:key="index" v-for="(activityLog, index) in activitiesLogs.data">
                        <td :class="'text-center '+ getVariant(activityLog.description.type)">
                            {{activityLog.id}}
                        </td>
                        <td :class="'text-center ' + getVariant(activityLog.description.type)">
                            {{activityLog.date}}
                        </td>
                        <td :class="'text-center ' + getVariant(activityLog.description.type)">
                            {{activityLog.time}}
                        </td>
                        <td v-if="activityLog.description.loggedInUser"
                            :class="'text-center ' + getVariant(activityLog.description.type)">
                            <span style="display:block;" class="mb-1">
                                {{activityLog.description.ip}}
                            </span>
                            <span style="direction: rtl">
                                {{activityLog.description.loggedInUser}} : {{ $t('label.loggedInUser') }}
                            </span>
                        </td>
                        <td v-else :class="'text-center ' + getVariant(activityLog.description.type)">
                            {{activityLog.description.ip}}
                        </td>
                        <td :class="'text-center ' + getVariant(activityLog.description.type)">
                            <country-flag v-if="activityLog.description.country_code != null" :country="activityLog.description.country_code" size="normal"/>
                            <span v-else> - </span>
                        </td>
                        <td class="text-right created-log" v-if="activityLog.description.attributes">
                            <kt-form-label >
                                action_type:
                            </kt-form-label>
                            <span>
                                {{activityLog.description.description_type}} ||
                            </span>
                            <kt-form-label>
                                subject:
                            </kt-form-label>
                            <span >
                                 {{activityLog.description.subject_type}} ||
                            </span>
                            <br>
                            <kt-form-label>
                                attributes:
                            </kt-form-label>
                            <span >
                                {{activityLog.description.attributes}}
                            </span>
                        </td>
                        <td class="text-right updated-log" v-else-if="activityLog.description.changes" >
                            <kt-form-label>
                                action_type:
                            </kt-form-label>
                            <span >
                                {{activityLog.description.description_type}} ||
                            </span>
                            <kt-form-label>
                                subject:
                            </kt-form-label>
                            <span >
                                 {{activityLog.description.subject_type}} ||
                            </span>
                            <kt-form-label>
                                changes:
                            </kt-form-label>
                            <br>
                            <kt-form-label>
                                new:
                            </kt-form-label>
                            <span >
                                 {{activityLog.description.changes.new}}
                            </span>
                            <br>
                            <kt-form-label>
                                old:
                            </kt-form-label>
                            <span >
                                 {{activityLog.description.changes.old}}
                            </span>
                        </td>
                        <td class="text-right updated-log" v-else-if="activityLog.description.event" >
                            <kt-form-label>
                                action_type:
                            </kt-form-label>
                            <span>
                                {{activityLog.description.event}}
                            </span>
                        </td>
                        <td class="text-right viewed-log" v-else>
                            <kt-form-label>
                                url:
                            </kt-form-label>
                            {{activityLog.description.url}}
                        </td>
                    </tr>
                    </tbody>
                </kt-table>
                <div class="pager kt-datatable--paging-loaded">
                    <div class="paginationR">
                        <button class="btn-link" title="اولی"
                                @click="changePage(1)">
                            &laquo;&laquo;
                        </button>
                        <button class="btn-link" title="قبلی"
                                @click="changePage(activitiesLogs.current_page - 1)">
                            &laquo;
                        </button>
                        <span v-for="(page, index) in ((activitiesLogs.current_page) - 2, activitiesLogs.current_page + 2)"
                              :key="index"
                        >
                            <button v-if="(page <= activitiesLogs.last_page) && page > activitiesLogs.current_page -3"
                                    @click="changePage(page)"
                                    :id="'page_' + page"
                            >
                                {{ page }}
                            </button>
                        </span>
                        <button class="btn-link" title="بعدی"
                                @click="changePage(activitiesLogs.current_page + 1)">
                            &raquo;
                        </button>
                        <button class="btn-link" title="آخری"
                                @click="changePage(activitiesLogs.last_page)">
                            &raquo;&raquo;
                        </button>
                    </div>
                    <div class="pager-info">
                        <select class="mr-3 ml-3 kt-datatable__pager-size" style="width: 60px;" title="اندازه صفحه"
                                @change="changePage(activitiesLogs.current_page)"
                                id="perpage-value"
                                v-model="per_page"
                        >
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                        </select>
                        <span class="kt-datatable__pager-detail">
                            {{ 'نمایش ' + activitiesLogs.from + ' - ' + activitiesLogs.to + ' از ' + activitiesLogs.total }}
                        </span>
                    </div>
                </div>
            </kt-col>
        </kt-row>
    </div>
</template>

<script>

    import {mapGetters} from "vuex";
    import GoBackBar from "../../components/custom/go-back-bar";
    import ActivityLogFilter from './components/activity-log-filter'
    import CountryFlag from 'vue-country-flag'
    import $ from "jquery";

    export default {
        name: 'PfUserActivityLog',
        components: {
            GoBackBar,
            CountryFlag,
            'activity-log-filter': ActivityLogFilter
        },
        data() {
            return {
                hashid: this.$route.params.hashid,
                per_page: localStorage.getItem('activity_log_per_page'),
                query: {},
                page: 1,
                params: {}
            }
        },
        computed: {
            ...mapGetters('user', [
                'status',
                'activitiesLogs'
            ])
        },
        mounted() {
            this.fillParams()
            this.$store.dispatch('user/fetchActivitiesLogs', this.params).finally(() => {
                $('#page_' + this.activitiesLogs.current_page).addClass('active')
            })
        },
        methods: {
            fillParams() {
                this.params= {
                    hashid: this.hashid,
                    pagination: {
                        page: this.page,
                        perpage: this.per_page
                    },
                    page: this.page,
                    perpage: this.per_page,
                    query: this.query
                }
            },
            changePage(pagee) {
                this.page = pagee
                this.fillParams()
                this.$store.dispatch('user/fetchActivitiesLogs', this.params).finally(() => {
                    $('#page_' + this.activitiesLogs.current_page).addClass('active')
                    localStorage.setItem('activity_log_per_page', this.activitiesLogs.per_page)
                })
            },
            getVariant(type) {
                if (type == 'create')
                    return 'created-log';
                else if (type == 'update')
                    return 'updated-log';
                else if (type == 'view')
                    return 'viewed-log';
                else
                    return 'badge-danger';
            },
            filterAction(e, query) {
                this.query = query
                this.fillParams()
                this.$store.dispatch('user/fetchActivitiesLogs', this.params).finally(() => {
                    $('#page_' + this.activitiesLogs.current_page).addClass('active')
                })
            }
        }
    }


</script>

<style >
    .table-hover tbody tr:hover td {
        background: #a7abc3;
    }
    @media screen and (min-width:300px){
        .time, .date, .ip{
            width: 30%;
        }
    }
    @media screen and (min-width:400px){
        .time, .date, .ip{
            width: 24% ;
        }
    }
    @media screen and (min-width:768px){
        .time, .date, .ip{
            width: 15% ;
        }
    }
    @media screen and (min-width:900px){
        .time, .date, .ip{
            width: 10%;
        }
    }

    .created-log {
        background-color: #62fb6b;
    }
    .updated-log {
        background-color: #ffec37
    }
    .viewed-log {
        background-color: #23c7d6ad
    }
    .table{
        table-layout: fixed;
    }
    td{
        word-wrap:break-word
    }
    .paginationR {
        display: -webkit-inline-box;
        margin: 40px;
    }
    .paginationR button {
        color: black;
        padding: 8px 16px;
        border: solid 0.5px #eaeaf1;
        background-color: #fff;
    }
    .paginationR button.active {
        background-color: #4CAF50;
        color: white;
    }
    .paginationR button:hover:not(.active) {
        background-color: #ddd;
    }
    .pager-info{
        display: inline-block;
    }
    .pager{
        margin: 40px;
        text-align: center;
    }
    .pager-info .kt-datatable__pager-size {
        font-size: 1rem;
        font-weight: 500;
        border: 0!important;
        color: #08123a;
        background: #f0f3ff;
        padding: 4px 8px;
    }
</style>